export const ALLOW_PROCEED_ORDINARY = 'ALLOW_PROCEED_ORDINARY'
export const allowProceedOrdinary = () => ({ type: 'ALLOW_PROCEED_ORDINARY' })

export const RESET_ORDINARY_PERMISSION = 'RESET_ORDINARY_PERMISSION'
export const resetOrdinaryPermission = () => ({ type: 'RESET_ORDINARY_PERMISSION' })

export const REJECT_ORDINARY_PERMISSION = 'REJECT_ORDINARY_PERMISSION'
export const rejectOrdinaryPermission = (permissionResult) => ({
  type: 'REJECT_ORDINARY_PERMISSION',
  payload: permissionResult,
})

export const VALIDATING_SALE_PERMISSION = 'VALIDATING_SALE_PERMISSION'
export const validatingSalePermission = () => ({
  type: 'VALIDATING_SALE_PERMISSION',
})

export const SALE_PERMISSION_VALIDATION_COMPLETED = 'SALE_PERMISSION_VALIDATION_COMPLETED'
export const salePermissionValidationCompleted = () => ({
  type: 'SALE_PERMISSION_VALIDATION_COMPLETED',
})
